import { Link } from 'react-router-dom';
import { useState } from 'react';

const footerLinks = {
  navigation: [
    { label: '首页', path: '/' },
    { label: '明星黑料', path: '/category/mingxing-heiliao' },
    { label: '网红爆料', path: '/category/wanghong-baoliao' },
    { label: '社会热点', path: '/category/shehui-redian' },
    { label: '综艺吃瓜', path: '/category/zongyi-chigua' },
  ],
  about: [
    { label: '关于我们', path: '/about' },
    { label: '品牌介绍', path: '/about' },
    { label: '联系我们', path: '/about' },
    { label: '用户口碑', path: '/about' },
  ],
  social: [
    { label: '微博', icon: 'ri-weibo-line', path: '#' },
    { label: '微信公众号', icon: 'ri-wechat-line', path: '#' },
    { label: '抖音', icon: 'ri-tiktok-line', path: '#' },
  ],
};

export default function Footer() {
  const [email, setEmail] = useState('');
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [statusMessage, setStatusMessage] = useState('');

  const handleSubscribe = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setSubmitStatus('loading');

    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypotVal = (formData.get('website_alt') as string || '').trim();

    if (honeypotVal) {
      setSubmitStatus('success');
      setStatusMessage('订阅成功！感谢您的关注');
      setEmail('');
      return;
    }

    try {
      const response = await fetch('http://chiguabao.cn/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({ email }).toString(),
      });
      const responseText = await response.text();
      let parsed: any = {};
      try { parsed = JSON.parse(responseText); } catch { /* ignore */ }

      if (response.ok && parsed?.code === 'OK') {
        setSubmitStatus('success');
        setStatusMessage('订阅成功！感谢您的关注');
        setEmail('');
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || responseText;
        if (serverMsg.includes('spam')) {
          setSubmitStatus('error');
          setStatusMessage('提交失败，请稍后再试');
        } else {
          setSubmitStatus('error');
          setStatusMessage(serverMsg || '订阅失败，请稍后再试');
        }
      }
    } catch {
      setSubmitStatus('error');
      setStatusMessage('网络错误，请稍后再试');
    }
  };

  return (
    <footer className="bg-foreground-950 text-white">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-10 md:gap-8">
          <div className="lg:col-span-1">
            <Link to="/" className="inline-flex items-center gap-2 mb-5">
              <span className="font-heading text-xl md:text-2xl font-bold tracking-tight whitespace-nowrap text-white">
                <i className="ri-fire-line mr-1"></i>
                黑料视频
              </span>
            </Link>
            <p className="text-foreground-400 text-sm leading-relaxed">
              黑料24小时不打烊每日更新，国产黑料视频实时追踪。一站式浏览最新黑料爆料，吃瓜不迷路。
            </p>
          </div>

          <div>
            <h4 className="text-white font-semibold text-sm mb-4">
              <a href="#nav-section" className="hover:text-accent-400 transition-colors">快速导航</a>
            </h4>
            <ul className="flex flex-col gap-2.5">
              {footerLinks.navigation.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.path}
                    className="text-foreground-400 hover:text-accent-400 transition-colors text-sm whitespace-nowrap"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold text-sm mb-4">
              <a href="#about-section" className="hover:text-accent-400 transition-colors">关于本站</a>
            </h4>
            <ul className="flex flex-col gap-2.5">
              {footerLinks.about.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.path}
                    className="text-foreground-400 hover:text-accent-400 transition-colors text-sm whitespace-nowrap"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold text-sm mb-4">
              <a href="#follow-section" className="hover:text-accent-400 transition-colors">关注我们</a>
            </h4>
            <ul className="flex flex-col gap-3">
              {footerLinks.social.map((item) => (
                <li key={item.label}>
                  <a
                    href={item.path}
                    className="flex items-center gap-2.5 text-foreground-400 hover:text-accent-400 transition-colors text-sm"
                    rel="nofollow"
                  >
                    <span className="w-5 h-5 flex items-center justify-center">
                      <i className={item.icon}></i>
                    </span>
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold text-sm mb-4">
              <a href="#subscribe-section" className="hover:text-accent-400 transition-colors">订阅更新</a>
            </h4>
            <p className="text-foreground-400 text-xs mb-3">第一时间获取最新黑料爆料</p>
            <form onSubmit={handleSubscribe} id="newsletter-form">
              <div className="flex gap-0">
                <label htmlFor="footer-email" className="sr-only">邮箱地址</label>
                <input
                  id="footer-email"
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="输入邮箱"
                  required
                  className="flex-1 min-w-0 px-3 py-2 text-sm bg-foreground-800 text-white placeholder:text-foreground-500 rounded-l-lg outline-none border border-foreground-700 focus:border-accent-500 transition-colors"
                />
                <button
                  type="submit"
                  disabled={submitStatus === 'loading'}
                  className="px-4 py-2 bg-accent-500 hover:bg-accent-600 text-white rounded-r-lg transition-colors cursor-pointer disabled:opacity-50 flex items-center justify-center whitespace-nowrap"
                >
                  {submitStatus === 'loading' ? (
                    <i className="ri-loader-4-line animate-spin text-sm"></i>
                  ) : (
                    <i className="ri-send-plane-fill text-sm"></i>
                  )}
                </button>
              </div>
              <input
                type="text"
                name="website_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                className="website_alt_field"
              />
              {submitStatus === 'success' && (
                <p className="text-accent-400 text-xs mt-2">{statusMessage}</p>
              )}
              {submitStatus === 'error' && (
                <p className="text-red-400 text-xs mt-2">{statusMessage}</p>
              )}
            </form>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-foreground-800/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-foreground-500 text-xs">
            &copy; {new Date().getFullYear()} 黑料视频 版权所有 | 黑料24小时不打烊，每日更新最新爆料
          </p>
          <div className="flex items-center gap-4 text-foreground-500 text-xs">
            <a href="#" className="hover:text-accent-400 transition-colors" rel="nofollow">隐私政策</a>
            <a href="#" className="hover:text-accent-400 transition-colors" rel="nofollow">用户协议</a>
            <a href="#" className="hover:text-accent-400 transition-colors" rel="nofollow">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}